import { Injectable, OnDestroy, TemplateRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { filter } from 'rxjs/operators';
import { OrgsListData } from '../../interfaces/org-management';
import { OrgService } from './org.service';

@Injectable()
export class OrgManagementStateService implements OnDestroy {
  private orgsSubject = new BehaviorSubject<OrgsListData[] | null>(null);
  private headerActionsSubject = new BehaviorSubject<TemplateRef<void> | null>(null);
  private destroy$ = new Subject<void>();

  orgs$: Observable<OrgsListData[]> = this.orgsSubject.pipe(filter((orgs): orgs is OrgsListData[] => orgs !== null));
  headerActions$ = this.headerActionsSubject.asObservable();

  setHeaderActions(tpl: TemplateRef<void>): void {
    this.headerActionsSubject.next(tpl);
  }

  clearHeaderActions(): void {
    this.headerActionsSubject.next(null);
  }

  constructor(private orgService: OrgService) {
    this.load();
  }

  load(): void {
    this.orgService
      .listOrgs()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (orgs) => this.orgsSubject.next(orgs),
      });
  }

  refresh(): void {
    this.load();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
